<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Add navigation tabs -->
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'group' }"
            @click="activeTab = 'group'">
            Grup Ayarları
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer text-secondary" :class="{ active: activeTab === 'bonusSettings' }"
            @click="activeTab = 'bonusSettings'">
            Bonus Ayarları
          </a>
        </li>

      </ul>

      <!-- Dealer Edit Form -->
      <div class="row" v-show="activeTab === 'group'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">İşbirliği Grubu Düzenle</h4>
              <p class="card-category">İşbirliği grubunu düzenleyin.</p>


              <form class="m-5">
                <div class="row">

                  <div class="col-md-6">
                    <base-input type="text" label="Grup Kodu" placeholder="Grup Kodu"
                      v-model="group.code">
                    </base-input>
                  </div>

                  <div class="col-md-6">
                    <base-input type="text" label="Grup Adı (Başlık)" placeholder="Grup Adı" v-model="group.title">
                    </base-input>
                  </div>   
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <base-input type="text" label="İletişim Kişisi" placeholder="İletişim Kişisi" v-model="group.contactPerson">
                    </base-input>
                  </div>

                  <div class="col-md-6">
                    <base-input type="text" label="Açıklama" placeholder="Açıklama" v-model="group.notes">
                    </base-input>
                  </div>
                </div>




                <div class="row pt-5">
                  <div class="col-md-12">
                    <label>Aktif Mi?</label>
                    <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="group.isActive"
                      :checked="group.isActive" @click="group.isActive = !group.isActive"></base-checkbox>
                  </div>
                </div>






                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="updateGroup()">
                    Güncelle
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </template>
          </card>

        </div>
      </div>

      <!-- Bonus Settings Edit Form -->
      <div class="row" v-show="activeTab === 'bonusSettings'">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">İşbirliği Grup Bonus Ayarları</h4>
              <p class="card-category">İşbirliği grup bonus ayarlarını düzenleyin. Oynanma aralığı ekleyerek ,ne kadar bonus verileceğini yönetebilirsiniz.</p>
              <p class="card-category">Aralık ayarları şöyle olmalıdır. <br>50.000 TL - 100.000 TL = %1 bonus<br> 100.000 TL - 200.000 TL = %2 bonus<br> 200.000 TL - 300.000 TL = %3 bonus <br> Oynanan miktar, minimum çevirime eşit olabilir, maksimum çevirime eşit olamaz. Aralık bırakmamak önemlidir.</p>
              
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <label>Çevirim Aralıkları</label>
                    
                    <!-- Machine Cards -->
                    <div v-for="(setting, index) in group.bonusSettings" :key="index" class="card mb-4">
                      <div class="card-body">
                        <div class="d-flex justify-content-between mb-3">
                          <h5 class="card-title">#{{index + 1}}</h5>
                          <button class="btn btn-danger btn-sm btn-fill" @click="removeBonusSetting(index)">
                            <i class="fa fa-trash"></i> Sil
                          </button>
                        </div>

                        <!-- Basic Info -->
                        <div class="row mb-3">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Minimum Çevirim (TL) </label>
                              <input type="number" class="form-control" v-model="setting.minCover" placeholder="Makina Adı">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Maksimum Çevirim (TL)</label>
                              <input type="number" class="form-control" v-model="setting.maxCover" placeholder="Markası">
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Bonus Oranı (%)</label>
                              <input type="number" min="0" step="0.01" max="5" class="form-control" v-model="setting.bonusRate" placeholder="Bonus Oranı">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-center mb-4">
                      <button class="btn btn-primary" @click="addBonusSetting()">
                        <i class="fa fa-plus"></i> Yeni Aralık Ekle
                      </button>
                    </div>
                  </div>
                </div>

                <div class="text-center">
                  <button type="submit" class="btn btn-info btn-fill mb-3" @click="updateGroup()">
                    <i class="fa fa-save"></i> Bonus Ayarlarını Güncelle
                  </button>
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      group: {
        title: "",
        code: "",
        contactPerson: "",
        notes: "",
        bonusSettings: [],
        isActive: true
      },
      activeTab: 'group',
      groupBonusSummary: [{
        week: "01-01-2025 / 07-01-2025",
        totalCover: 123213,
        totalBonus: 12321
      },
      {
        week: "08-01-2025 / 14-01-2025",
        totalCover: 212321,
        totalBonus: 5234
      },
      {
        week: "15-01-2025 / 21-01-2025",
        totalCover: 654443,
        totalBonus: 12312
      }]
    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getGroup();
  },
  methods: {
    updateGroup() { 

      this.group.bonusSettings = this.group.bonusSettings.map(setting => ({
        ...setting,
        minCover: parseFloat(setting.minCover),
        maxCover: parseFloat(setting.maxCover),
        bonusRate: parseFloat(setting.bonusRate)
      }));
      CollectionService.updateCollectionItem('affiliate-group', this.group._id, this.group).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "İşbirliği Grubu Güncellendi")
          this.$router.push(`/admin/affiliate-groups`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getGroup() {
      console.log(this.id)
      CollectionService.getCollectionItemWithId('affiliate-group', this.id).then((res) => {
        this.group = res.affiliateGroup;
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    addBonusSetting() {
      this.group.bonusSettings.push({
        minCover: 0,
        maxCover: 0,
        bonusRate: 0
      })
    },
    removeBonusSetting(index) {
      this.group.bonusSettings.splice(index, 1);
    }
  }
}
</script>
<style>
.nav-tabs .nav-link {
  cursor: pointer;
}

.attributes-container {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 15px;
  background-color: #f8f9fa;
}

.attributes-container .form-control-sm {
  width: 45%; /* Adjust as needed */
}

.attributes-container .btn-sm {
  padding: 0.25rem 0.5rem;
}
</style>